
export default {
  name: "ProductMaterialSelectView",
  props: {
    block: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalValue() {
      if (this.selectedItem?.sku) {
        return this.selectedItem.sku;
      }
      const firstAvailable = this.materials.find((m) => !m.disabled);
      return firstAvailable?.sku || "";
    },
    materials() {
      if (!this.block || !this.block.materials) {
        return [];
      }

      const mapped = this.block.materials.map((material) => {
        const title =
          material.currentTranslation?.title ||
          material.mixedTranslation?.title ||
          material.title ||
          material.sku ||
          "";
        return {
          ...material,
          title,
          disabled: material.disabled || false,
        };
      });

      return mapped;
    },
  },
  mounted() {
    if (!this.selectedItem && this.materials.length > 0) {
      const firstAvailable = this.materials.find((m) => !m.disabled);
      if (firstAvailable) {
        const currentItem = this.block.materials.find(
          (material) => material.sku === firstAvailable.sku
        );
        if (currentItem) {
          this.$emit("filter", {
            slug: this.block.slug,
            item: currentItem,
          });
        }
      }
    }
  },
  methods: {
    onUpdate(event) {
      const value = event.target.value;
      const currentItem = this.block.materials.find(
        (material) => material.sku === value
      );

      this.$emit("filter", {
        slug: this.block.slug,
        item: currentItem,
      });
    },
  },
};
